import React, { Component } from 'react';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Modal } from 'reactstrap';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
export class Activity extends Component<any> {
    state = {
      
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }




    public render() {
  
        return (
            <Modal
            id="activity-popup"
            keyboard={false}
            isOpen={true}
            className="modal-dialog"
            style={{ maxWidth: '1150px'}}
        >
            <div>
            <div className="white-box shadow">
                <div className="conversation-header d-flex align-items-center justify-content-between w-100 pr-3">
                            <div className="userinfo media align-items-center">
                                <div className="media-body p-2">
                                    <span className="d-flex">
                                        {T.t('r_upcoming_activities')}
                                    </span>
                                </div>
                            </div>

                            <button type="button" className="close ml-0" onClick={this.props.triggerActivity}   aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                 </div>
            </div>
            <div className='row m-0'>
                <div className='col-12 pr-2 pl-2 pb-2'>
<div className='row m-0 p-2' style={{borderLeft: '3px solid #b33e7c', backgroundColor: '#fbfaf6'}}>

    <div className='col-1 d-flex justify-content-center' style={{alignItems: "center"}}><img
                                    className="notes-icon"
                                    src={_common.GetActivityTypeIcons('assignment')}
                                    alt="Assignment Activity Icon"
                                /></div>
    <div className='col-7 align-center d-flex justify-content-center' style={{alignItems: "center"}}>Test yazısı, api bağlanınca güncellenecek.</div>
    <div className='col-2 text-center d-flex justify-content-center' style={{alignItems: "center"}}>12.02.2024 12:00</div>
    <div className='col-2 align-middle'>   <button
                                        type="button"
                                        className="success-btn"                            
                                    >
                                        {T.t('r_view_activity')}
                                    </button></div>
</div>


                </div>
                </div>

            </div>
            </Modal>
        );
    }
}

export default Activity;
